import { Company } from '@models/companies/company';
import { Entity } from '@models/companies/entity';
import { SecurityChange } from '@models/documents/security-change';
import { IEdgeDocument } from '@models/edge/edge-document';
import { CorporateHolderModel, IndividualHolderModel } from '@models/shares/security-registry-record';
import { CompanyChangeData } from "@models/ui-models/company-change-data";
import { NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { BaseShareFormComponent } from "../../asic-forms/shares/base-share-form/base-share-form.component";
import { SecurityTransactionBalance } from '../company/company-registration.model';

export class EntitySecurityBalance<TEntity extends Entity> extends SecurityChange<TEntity> implements IEdgeDocument {
  balance!: SecurityTransactionBalance;
  securityHolders: (IndividualHolderModel | CorporateHolderModel)[];

  constructor(data: Partial<EntitySecurityBalance<TEntity>> = {}) {
    super(data);
    this.balance = data.balance ? new SecurityTransactionBalance(data.balance) : new SecurityTransactionBalance();
    this.securityHolders = data.securityHolders?.filter(Boolean).map(holder => {
      switch (holder.$type) {
        case 'IndividualHolderModel':
          return new IndividualHolderModel(holder);
        case 'CorporateHolderModel':
          return new CorporateHolderModel(holder);
        default:
          throw new Error(`Unknown holder type: ${ holder.$type }`);
      }
    }) ?? [];
  }
}

export class CompanySecurityBalance extends EntitySecurityBalance<Company> {
  static override readonly $type = 'CompanySecurityBalance';

  constructor(data: Partial<CompanySecurityBalance> = {}) {
    super(data);
  }

  override fillModalWithCompany(modalRef: NgbModalRef, company: Company, isEdit: boolean): NgbModalRef {
    const instance = modalRef.componentInstance as BaseShareFormComponent<{}, CompanySecurityBalance>;

    instance.isEdit = isEdit;
    instance.companyChangeData = new CompanyChangeData(company);
    instance.formModel = this;
    instance.hasShareIssue = BaseShareFormComponent.isCompanyIncludeShareIssue(company);

    return modalRef;
  }

  override prepareToRequest(): CompanySecurityBalance {
    return {
      ...this,
      ...super.prepareToRequest(),
      balance: this.balance.prepareToRequest()
    };
  }
}
